import styles from './css/PrevNextArticles.module.css';
import useFetch from '../../Hooks/useFetch';
import { Link } from 'react-router-dom';

const PrevNextArticles = ({ currentArticle }) => {
  const { data: previousArticle } = useFetch(
    `news-articles?populate=*&pagination[pageSize]=1&filters[id][$lt]=${currentArticle.data.id}&sort[0]=id:desc`,
  );

  const { data: nextArticle } = useFetch(
    `news-articles?populate=*&pagination[pageSize]=1&filters[id][$gt]=${currentArticle.data.id}`,
  );

  return (
    <section className={`${styles.prevNextArticles} container`}>
      {previousArticle?.data.length > 0 && (
        <div className={styles.previousArticle}>
          <Link to={`/news/${previousArticle.data[0].documentId}`}>
            <img
              src={
                process.env.REACT_APP_API_URI + previousArticle.data[0].featured_image.formats.thumbnail.url
              }
              alt=''
              height={75}
              width={75}
              className={styles.prevNextImage}
            />
            <div className=''>
              <p className={styles.prevNextText}>Previous Post</p>
              <p className={styles.prevNextTitle}>
                {previousArticle.data[0].title.substring(0, 30) + ' ...'}
              </p>
            </div>
          </Link>
        </div>
      )}
      {nextArticle?.data.length > 0 && (
        <div className={styles.nextArticle}>
          <Link to={`/news/${nextArticle.data[0].documentId}`}>
            <div className=''>
              <p className={styles.prevNextText}>Next Post</p>
              <p className={styles.prevNextTitle}>{nextArticle.data[0].title.substring(0, 30) + ' ...'}</p>
            </div>
            <img
              src={process.env.REACT_APP_API_URI + nextArticle.data[0].featured_image.formats.thumbnail.url}
              alt=''
              height={75}
              width={75}
              className={styles.prevNextImage}
            />
          </Link>
        </div>
      )}
    </section>
  );
};
export default PrevNextArticles;
